import { combineReducers } from 'redux'
import $$byId from 'components/agents/reducers/byId'
import $$allIds from 'components/agents/reducers/allIds'

export default combineReducers({
  $$byId,
  $$allIds,
})
